<template>
  <div class="app-main-content bill-overseas-s-center-view">
    <div
      class="main-content"
      type="primary"
    >
      <query-bill-overseas-accept-condition
        ref="queryBillOverseasAcceptCondition"
      >
        <template slot="operations">
          <div style="float: left;">
            <el-button style="margin-left: 10px" type="primary" @click="toQuery()">
              {{ $t('CargoMsg.Cargo_Query') }}
            </el-button>
            <el-button v-show="$checkPermission(['button_BillOverseasSCenter_writeOffs'])" type="primary" @click="overseaBtnEventHandler()">{{ $t('CargoMsg.Cargo_WriteOff') }}</el-button>
            <el-button v-show="$checkPermission(['button_BillOverseasSCenter_billOverseasReturn'])" type="primary" @click="toReturn()">{{ $t('CargoMsg.Cargo_Return') }}</el-button>
            <el-button type="primary" @click="resetSearch()">{{ $t('CargoMsg.Cargo_ResetFilter') }}</el-button>
            <el-button type="primary" @click="onPrint()">{{ $t('CargoMsg.Cargo_Print') }}</el-button>
            <el-upload
              v-show="$checkPermission(['button_BillOverseasSCenter_importAndQuery'])"
              :action="URL.act.billing.importAndQueryBilling"
              :headers="{sessionId}"
              :show-file-list="false"
              accept=".xls, .xlsx"
              :on-success="importSuccess"
              :data="option"
              style="display: inline-block; margin-left: 5px"
            >
              <el-button type="primary">{{ $t('CargoMsg.Cargo_ImportAndQueryOfBillNumber') }}</el-button>
            </el-upload>
          </div>
        </template>
      </query-bill-overseas-accept-condition>
    </div>
    <bill-overseas-s-center-grid
      config-module="410015203"
      :row-data="rowData"
      :filter="filter"
      :grid-options="gridOptions"
    />
    <!-- 打印报表对话框 -->
    <cargo-template-select-dialog
      :visible.sync="templateSelectorDialog.visible"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      :ctx="templateSelectorDialog.ctx"
    />
    <!-- 销账 or 对冲销账 -->
    <write-off-dialog v-if="writeOffDialog.visible" ref="dgWriteoff" :visible.sync="writeOffDialog.visible" :title="title" :params="writeOffDialog.params" :properties="this.properties" @writeoffSuccessHandler="writeoffSuccessHandler" />
  </div>
</template>

<script>
import { getLoading } from '@/utils/utilBaseElement'
import AmountSumMaster from '@/views/cargo/v0/Clearing/components/FinanceChargeSearch/AmountSumMaster'
import { queryBillOverseas, batchUpdateStates } from '@/api/clearing/billingNative'
import StrUtils from '@/utils/StrUtils'
import CargoTemplateSelectDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import QueryBillOverseasAcceptCondition from '@/views/cargo/v0/Clearing/BillOverseasSCenter/components/query/queryBillOverseasAcceptCondition'
import BillOverseasSCenterGrid from '@/views/cargo/v0/Clearing/BillOverseasSCenter/components/grid/billOverseasSCenterGrid'
import moment from 'moment'
import WriteOffDialog from '@/views/cargo/v0/Clearing/components/Writeoff/writeOffDialog'
import { getNotWriteoffCharges } from '@/api/clearing/actualAmount'
import { getObjectByCache } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import URL from '@/api/urlTranslator'
import { ClearingUtils } from '@/class/cargo/model/utils/ClearingUtils'
export default {
  name: 'BillOverseasSAcceptView',
  components: { WriteOffDialog, BillOverseasSCenterGrid, QueryBillOverseasAcceptCondition, CargoTemplateSelectDialog, AmountSumMaster },
  data() {
    return {
      URL,
      fullscreenLoading: null,
      rowData: [],
      numAll: 100,
      numSelected: 0,
      sumCredit: '',
      sumDebit: '',
      selectedRows: [],
      filter: {
        pageNum: 1,
        pageSize: 100
      },
      writeOffDialog: {
        visible: false,
        params: {}
      },
      // 模板选择弹窗
      templateSelectorDialog: {
        visible: false,
        category: 'BILLING',
        data: {},
        ctx: null,
        printedCallback: null
      },
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowDoubleClicked: this.onRowDoubleClicked,
        onRowClicked: this.onGridRowClickedEvent,
        onSelectionChanged: (event) => {
          this.selectedRows = event.api.getSelectedRows()
        }
      },
      properties: {
        isExt: false, // ext
        entities: [], // 销账实体
        hedgeEntities: null, // 对冲实体
        allEntities: [], // 所有实体
        isAr: false, // 是否应收
        isHedge: false, // 是否对冲
        isEntitiesAr: false, // 是否应收
        isHedgeEntitiesAr: false, // 是否应收
        rpDate: moment().format('yyyy-MM-DD'), // 收付日期
        isOversea: true, // 是否海外销账
        defaultCurrency: 'USD', // 默认币种
        accountId: 0, // 结算单位
        chargeAccountIds: [], // 按费用销账结算单位
        hedgeChargeAccountIds: [],
        writeoffByDifferentAccount: false, // WriteoffByDifferentAccount, 不同结算单位合并销账
        writeoffCheckBillpaymentDone: false, // WriteoffCheckBillpaymentDone, 销账号确认付款流程已经走完
        mustUseActualAmountWriteoff: false, // MustUseActualAmountWriteoff, 是否必须使用实收付销账
        isHQWriteoffConfirm: false, // isHQWriteoffConfirm, 是否需要通过总部核销(UBI)
        isWriteoffCurrencyByInvoice: false, // isWriteoffCurrencyByInvoice, 销账默认按费用币种，缺省值0；可选项1（按发票销账时，默认取发票币种）
        payAfterPayApply: false, // PayAfterPayApply, 需申请后才能付款
        allowWriteOffDiffBranch: true, // 正操作的数据所在分公司不属于当前分公司或上一级分公司的情况是否允许销账
        actualAmount: {}, // 实收实付
        selectedEntities: [], // 已经选中的实体
        selectedEntitiesHedge: [], // 已经选中的对冲实体
        selectedEntitiesOrigin: [], // 已经选中的实体(原记录)
        writeOffMode: 3, // 销账模式: 1=费用、2=发票、3=账单、4=对账单、5=付款申请
        writeOffModeHedge: 3, // 销账模式: 1=费用、2=发票、3=账单、4=对账单、5=付款申请
        currencys: [], // 费用所包含的币种
        otherCurrencyRate: [] // 其它币种和汇率
      }
    }
  },
  computed: {
    sessionId() {
      return this.$store.getters.token
    },
    // 标题
    title() {
      let title = this.properties.isOversea ? this.$t('CargoMsg.Cargo_OverseasWriteOff') : (this.properties.isHedge ? this.$t('WriteOff.hedgingWriteOffs') : this.$t('WriteOff.writeOffs'))
      if (this.properties.accountId > 0) {
        const company = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(this.properties.accountId))
        if (company) {
          if (this.$t('WriteOff.writeOffs') === title) {
            if (!this.properties.writeoffByDifferentAccount) {
              const isChinese = this.$store.getters.language === 'zh'
              title += ' - ' + (isChinese ? company.chineseName : company.englishName)
            }
          } else {
            const isChinese = this.$store.getters.language === 'zh'
            title += ' - ' + (isChinese ? company.chineseName : company.englishName)
          }
        }
      }
      return title
    },
    option() {
      if (!this.$refs['queryBillOverseasAcceptCondition']) {
        return {}
      }
      const option = this.$refs['queryBillOverseasAcceptCondition'].getSearchOption()
      option['limit'] = this.filter.pageSize
      option['state'] = 5
      return option
    }
  },
  methods: {
    toQuery() {
      const option = this.$refs['queryBillOverseasAcceptCondition'].getSearchOption()
      if (option.isMerge && !option.hasOwnProperty('accountId')) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseEnterCorrectBillingParty'))
        return
      }
      option['limit'] = this.filter.pageSize
      option['state'] = 5
      this.fullscreenLoading = getLoading()
      queryBillOverseas(option).then(res => {
        this.rowData = res.data
        this.loadingEnd()
      }).catch(() => {
        this.fullscreenLoading.close()
      })
    },
    importSuccess(res) {
      this.rowData = res.data
      this.loadingEnd()
    },
    loadingEnd() {
      this.gridOptions.api.clearFocusedCell()
      this.fullscreenLoading.close()
      this.selectedRows = []
    },
    toReturn() {
      this.updateState()
    },
    overseaBtnEventHandler() {
      const selectRows = this.selectedRows
      if (!selectRows || selectRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectBill'))
        return
      }
      for (const billing of selectRows) {
        if (StrUtils.isEmpty(billing.billingNo)) {
          this.$message.warning(this.$t('CargoMsg.Cargo_OnlyBillsWithBillingNumbersCanBeWriteOff'))
          return
        }
        if (this.chargeIsPadOff(billing)) {
          const msg = StrUtils.substitute(this.$t('CargoMsg.Cargo_BillsHasBeenPaidInFull'), billing.billingNo)
          this.$message.warning(msg)
          return
        }
        if (typeof billing.company !== 'object') {
          billing.company = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', billing.accountId) || null
        }
      }
      let company = {}
      const accountID = selectRows[0].accountId
      let isDifferent = false
      const companyKeys = []
      let hasNoneGlobal = false
      if (selectRows.length > 1) {
        for (const b of selectRows) {
          if (b.accountId !== accountID) {
            isDifferent = true
          }
          if (b.company.isGlobal) {
            companyKeys.push(b.company.key)
            company = b.company
          } else {
            if (b.company.globalAccount) {
              companyKeys.push(b.company.globalAccount.key)
            } else {
              hasNoneGlobal = true
            }
          }
        }
        // 结算对象不一致
        if (isDifferent) {
          let isDifferentAndNoneGlobal = false
          // 没有归并
          if (hasNoneGlobal) {
            isDifferentAndNoneGlobal = true
          }
          const key = companyKeys[0]
          if (this.hasKey(companyKeys, key)) {
            isDifferentAndNoneGlobal = true
          }
          if (isDifferentAndNoneGlobal) {
            const isDifferentSettlementAgent = !(selectRows[0].settlementAgentId && ClearingUtils.isSameSettlementAgent(selectRows))
            if (isDifferentSettlementAgent) {
              this.$message.warning(this.$t('CargoMsg.Cargo_SPIANA_DiffSettlementAgent'))
              return
            }
          }
          if (!company) {
            company = selectRows[0].company.globalAccount
          }
        } else {
          company = selectRows[0].company
        }
      } else {
        company = selectRows[0].company
      }
      this.writeoff()
    },
    writeoff() {
      if (!this.checking()) {
        return
      }
      const keys = []
      for (const item of this.selectedRows) {
        keys.push(item.uuid)
      }
      const properties = this.properties
      const requestBody = { 'keys': keys, 'classType': 'billing', 'isOversea': true, 'officeId': this.$store.getters.currentOfficeId }
      this.loading = getLoading()
      getNotWriteoffCharges(requestBody).then(res => {
        console.log('getNotWriteoffCharges', res)
        this.properties.entities = res.data
        this.properties.allEntities = []
        this.properties.selectedEntities = this.properties.entities
        this.properties.allEntities.push(...this.properties.entities)
        properties.isAr = this.getBillingAr()
        this.writeOffDialog.visible = true
      }).finally(() => {
        this.loading.close()
      })
    },
    hasKey(companyKeys, key) {
      for (const item of companyKeys) {
        if (item !== key) {
          return true
        }
      }
      return false
    },
    writeoffSuccessHandler() {
      this.toQuery()
    },
    getBillingAr() {
      let t = 0
      let t1 = 0
      for (const b of this.selectedRows) {
        if (b.ar) {
          t += b.amount
        } else {
          t1 += b.amount
        }
      }
      return t > t1
    },
    // 退回,接受
    updateState() {
      const selectRows = this.selectedRows
      if (!selectRows || selectRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectBill'))
        return
      }
      for (const billing of selectRows) {
        if (this.getBillChargeAmount(billing) > 0) {
          this.$message.warning(this.$t('CargoMsg.Cargo_BillsAlreadyWriteOffFee', [billing.billingNo]))
          return
        }
      }
      this.$confirm(this.$t('CargoMsg.Cargo_SureDoThis'), this.$t('Pricing.Tips'), {
        confirmButtonText: this.$t('common.btn.yes'),
        cancelButtonText: this.$t('common.btn.no'),
        type: 'warning'
      }).then(() => {
        // 退回到已打印状态
        this.fullscreenLoading = getLoading()
        batchUpdateStates(selectRows, { state: 2 }).then(res => {
          this.$message.success(this.$t('CargoMsg.Cargo_OperationSuccessfully'))
          this.gridOptions.api.updateRowData({ 'remove': selectRows })
          this.loadingEnd()
        }).catch(() => {
          this.fullscreenLoading.close()
        })
      })
    },
    // 判断当前账单是否全部核销
    getBillChargeAmount(bill) {
      let amount = 0
      for (const charge of bill.charge) {
        charge.clearRemarks = ''
        amount = this.getChargeClearHistory(charge.clearHistory)
      }
      return amount
    },
    chargeIsPadOff(bill) {
      for (const charge of bill.charge) {
        const verifiedAmount = this.getChargeClearHistory(charge.clearHistory)
        if (charge.amount.toFixed(2) !== verifiedAmount.toFixed(2)) {
          return false
        }
      }
      return true
    },
    getChargeClearHistory(historys) {
      let chargeAmount = 0
      if (!historys) {
        return chargeAmount
      }
      for (const clearHistory of historys) {
        if (clearHistory.ar) {
          chargeAmount += clearHistory.clearamount / clearHistory.clearRate // (clearHistory.clearamount * RateUtil.getForeignExchangeRateByDate(clearHistory.chargeCurrency,clearHistory.actualCurrency,new Date()));
        } else {
          chargeAmount -= clearHistory.clearamount / clearHistory.clearRate // (clearHistory.clearamount * RateUtil.getForeignExchangeRateByDate(clearHistory.chargeCurrency,clearHistory.actualCurrency,new Date()));
        }
      }
      return Math.abs(chargeAmount)
    },
    resetSearch() {
      this.$refs['queryBillOverseasAcceptCondition'].resetSearch()
    },
    // 参照 ActualAmount.checkBillPaymentApproved --前端实现
    checking() {
      for (const charge of this.selectedRows) {
        if (!(!charge.receivable && (StrUtils.isEmpty(charge.billPaymentUuid) || charge.billPaymentState !== 3))) {
          this.$message.warning(this.$t('CargoMsg.Cargo_NotAllowWriteOffFee'))
          return false
        }
      }
      return true
    },
    onPrint() {
      const selectRows = this.selectedRows
      if (!selectRows || selectRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectBill'))
        return
      }
      const keyList = []
      for (const billing of selectRows) {
        keyList.push(billing.key)
      }
      const params = {
        BILLING_UUID_LIST: keyList,
        BILLING_UUID: keyList
      }
      // CARGO-6000，圣世特：V2模板，国内账单另存文件，文件名需要由模板名称+账单号组成
      if (selectRows.length === 1) {
        params['billingNo'] = selectRows[0].billingNo
        if (!StrUtils.isEmpty(selectRows[0].jobNo)) {
          params['jobNo'] = selectRows[0].jobNo
        }
      }
      this.templateSelectorDialog.visible = true
      this.templateSelectorDialog.ctx = null
      this.templateSelectorDialog.data = params
    }
  }
}
</script>

<style lang="scss">
.bill-overseas-s-center-view{
  .totalLabel{
    margin-top: 6px;
    margin-left: 10px;
    margin-right: 10px;
  }
}
</style>
